// Third-party
import React from 'react';
import classNames from 'classnames';

// Utils
import { formatPercentage, formatNumber } from '../../../utils/i18n';
import Locale from '@/types/locale';

type Props = {
  value: number;
  isPercentage?: boolean;
  className?: string;
  growth?: boolean;
  decimalPlace?: number;
  locale?: Locale;
  'aria-label'?: string;
};

export default function IntegerValue({ value, isPercentage, className, growth, decimalPlace = 2, locale, 'aria-label': ariaLabel }: Props) {
  const classes = classNames('integer-value', {
    positive: value > 0,
    negative: value < 0,
    className,
    growth,
  });

  if (value == null) {
    return <span className={classes}>-</span>;
  }

  return (
    <span className={classes} aria-label={ariaLabel}>
      {isPercentage ? formatPercentage(value, decimalPlace, locale) : formatNumber(value, decimalPlace, locale)}
    </span>
  );
}
